import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { cancelOrderModalStyles } from "./styles";
import InputField from "../../../Components/InputField";
import { useTranslation } from "react-i18next";

const CancelOrderModal = ({ open, onClose, onActionClick, isLoading }) => {
  const { t } = useTranslation("job-action-modals", {
    keyPrefix: "cancelOrderModal",
  });
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const {
    dialogTitleBoxStyle,
    dialogTitleStyle,
    dialogContent,
    dialogContentTextStyle,
    dialogActions,
    backButtonStyle,
    cancelButtonStyle,
    loader,
  } = cancelOrderModalStyles;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 4,
          maxWidth: "556px",
          width: "100%",
        },
      }}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <Box sx={dialogTitleBoxStyle}>
        <DialogTitle sx={dialogTitleStyle}>{t("dialogTitle")}</DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" sx={{ color: "rgba(62, 63, 76, 1)" }} />
        </IconButton>
      </Box>

      <DialogContent sx={dialogContent}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography sx={dialogContentTextStyle}>
            {t("dialogContentText")}
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <Typography
              sx={{
                ...dialogContentTextStyle,
                fontSize: "15px",
                lineHeight: "15px",
              }}
            >
              {t("reasonText")}
            </Typography>

            <InputField
              name="reason"
              placeholder={t("reasonPlaceholder")}
              multiline
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={dialogActions}>
        <Button variant="contained" sx={backButtonStyle} onClick={onClose}>
          {t("backButton")}
        </Button>

        <Button
          onClick={() => onActionClick(reason)}
          disabled={isLoading}
          sx={cancelButtonStyle}
        >
          {t("cancelButton")}
          {isLoading && <CircularProgress size={20} sx={loader} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelOrderModal;
